import { Digraph, Edge, Node, Subgraph, toDot } from 'ts-graphviz';
import { _keys, md5, resolveContent } from '@nu-art/ts-common';
import { ModuleFE_Referencable } from '../ModuleFE_Referencable.js';
const edgeTypePropertiesMap = {
    extends: {
        arrowhead: 'normal',
        weight: 10,
    },
    property: {
        arrowhead: 'normal',
        color: 'red',
        // constraint: false,
    },
    'property-value': {
        arrowhead: 'normal',
        color: 'green',
        // constraint: false,
    },
    'prop-inheritance': {
        arrowhead: 'normal',
        color: 'red',
        class: 'prop-inheritance'
    },
};
const getNode = (id, label) => new Node(id, {
    id: id,
    label: label,
    shape: 'rect',
    style: 'filled',
    fillcolor: '#ffffff',
    fontsize: 13,
    fontcolor: '#333333',
});
const getEdge = (originNode, targetNode, id, type) => new Edge([originNode, targetNode], {
    id,
    ...edgeTypePropertiesMap[type],
});
export const generateReferencableGraphStringV2 = (referencable, props) => {
    if (!referencable._id)
        return;
    //Create Graph
    const graph = new Digraph(undefined, {
        ranksep: 1,
        bgcolor: 'transparent'
    });
    const verticalStack = new Subgraph(undefined, { rank: 'same' });
    const nodeDict = {};
    const mainRefProperties = deriveRefProperties([referencable]);
    const inheritanceTree = deriveRefInheritanceTree(referencable);
    //Create clusters
    inheritanceTree.forEach(row => {
        row.forEach(ref => {
            const cluster = buildCluster_Ref(ref, nodeDict, {
                renderProperties: ref._id === referencable._id,
                refProperties: ref._id === referencable._id ? mainRefProperties : () => deriveRefProperties([ref]),
            });
            const mainNode = nodeDict[ref._id];
            if (!cluster)
                graph.addNode(mainNode);
            else
                graph.addSubgraph(cluster);
        });
    });
    //Go through the tree again - create global edges
    //At this point all nodes should already be created
    inheritanceTree.forEach(row => {
        row.forEach(ref => {
            const refNode = nodeDict[ref._id];
            const parentNodes = ref.extends.filter(id => id !== ref._id).map(id => nodeDict[id]);
            parentNodes.forEach(parentNode => {
                //Create parent edges
                graph.addEdge(getEdge(parentNode, refNode, md5(parentNode.id + refNode.id), 'extends'));
            });
            //Create prop inheritance edges
            if (ref._id !== referencable._id)
                mainRefProperties
                    .filter(property => property.originId === ref._id)
                    .map(property => nodeDict[property.property._id])
                    .forEach(node => {
                    graph.addEdge(getEdge(refNode, node, md5(ref._id + node.id), 'prop-inheritance'));
                });
        });
    });
    //Add the vertical stack to the graph
    graph.addSubgraph(verticalStack);
    return toDot(graph);
};
const deriveRefProperties = (referencables, properties = []) => {
    referencables.forEach(referencable => {
        _keys(referencable.properties).forEach(propertyId => {
            if (!referencable.properties[propertyId].length)
                return;
            //At the moment the latest wins, should implement a merging logic based on the ref type
            if (properties.find(el => el.property._id === propertyId))
                return;
            //Add this property to the array
            const property = ModuleFE_Referencable.cache.unique(propertyId);
            const values = referencable.properties[propertyId].map(valueId => ModuleFE_Referencable.cache.unique(valueId));
            properties.push({
                originId: referencable._id,
                property,
                values,
            });
        });
    });
    //Derive from parents
    const parents = referencables.map(i => i.extends.filter(id => id !== i._id)).flat().map(id => ModuleFE_Referencable.cache.unique(id));
    if (parents.length)
        deriveRefProperties(parents, properties);
    return properties;
};
const deriveRefInheritanceTree = (referencable) => {
    let parentIds = referencable.extends;
    const toRet = [[referencable]];
    while (parentIds.length) {
        const parents = parentIds.map(id => ModuleFE_Referencable.cache.unique(id));
        toRet.push(parents);
        parentIds = parents.map(parent => parent.extends.filter(id => id !== parent._id)).flat();
    }
    return toRet;
};
const buildCluster_Ref = (ref, nodeDict, props) => {
    const mainNode = getNode(ref._id, ref.label);
    nodeDict[ref._id] = mainNode;
    if (!props.renderProperties)
        return;
    const cluster = new Subgraph(`cluster-ref_${ref._id}`);
    cluster.addNode(mainNode);
    resolveContent(props.refProperties).forEach(property => {
        const propCluster = buildCluster_Property(ref, property.property, property.values, nodeDict);
        cluster.addSubgraph(propCluster);
        const propNode = nodeDict[property.property._id];
        cluster.addEdge(getEdge(mainNode, propNode, md5(ref._id + property.property._id), 'property'));
    });
    return cluster;
};
const buildCluster_Property = (context, property, values, nodeDict) => {
    const cluster = new Subgraph(`cluster-prop_${property._id}`);
    const mainNode = getNode(property._id, property.label);
    nodeDict[property._id] = mainNode;
    cluster.addNode(mainNode);
    values.forEach(value => {
        const valueNode = getNode(value._id, value.label);
        nodeDict[value._id] = valueNode;
        cluster.addNode(valueNode);
        cluster.addEdge(getEdge(mainNode, valueNode, md5(context._id + property._id + value._id), 'property-value'));
    });
    return cluster;
};
//# sourceMappingURL=utils.js.map